module.exports = __webpack_public_path__ + "src/app/uiComponents/studio/images/mobile-frame.png?276ae41e732b0bf97c463842dea795c7";